import React from 'react';
import { observer } from '../../shared/observer';
import { router } from '../../shared/hashRouter';
import { ProfileHome } from './ProfileHome';
import { Orders } from './Orders';
import { Addresses } from './Addresses';
import { Cards } from './Cards';
import { Settings } from './Settings';
import { Bonuses } from './Bonuses';
import { InviteFriend } from './InviteFriend';
import { OrderDetails } from './OrderDetails';

const ORDER_ROUTE = '#order/';

const ROUTES = {
  '#orders': Orders,
  '#addresses': Addresses,
  '#cards': Cards,
  '#settings': Settings,
  '#bonuses': Bonuses,
  '#invite': InviteFriend,
};

class ProfileAppView extends React.Component {
  componentWillMount() {
    this._routerSub = router.subject.subscribe(() => this.forceUpdate());
  }
  componentWillUnmount() {
    if (this._routerSub) this._routerSub.unsubscribe();
  }

  openLogin = () => this.props.auth.setLoginDialogOpen(true);

  render() {
    const auth = this.props.auth;
    if (!auth.isAuthenticated) {
      return (
        <div className="ng-cart-empty">
          <h1>Личный кабинет</h1>
          <p>Войдите, чтобы посмотреть заказы, адреса и настройки.</p>
          <button type="button" className="btn" onClick={this.openLogin}>Войти</button>
        </div>
      );
    }
    const hash = router.hash || '';

    // Страница заказа — единственный маршрут с параметром: #order/<id>.
    // Назад ведёт к списку заказов, а не в корень ЛК.
    if (hash.indexOf(ORDER_ROUTE) === 0) {
      return (
        <div className="ng-profile">
          <div className="ng-profile__nav">
            <a href="#orders" onClick={(e) => { e.preventDefault(); router.go('#orders'); }}>← Заказы</a>
          </div>
          <OrderDetails id={hash.slice(ORDER_ROUTE.length)} />
        </div>
      );
    }

    const Page = ROUTES[hash];
    if (Page) {
      return (
        <div className="ng-profile">
          <div className="ng-profile__nav">
            <a href="#" onClick={(e) => { e.preventDefault(); router.go(''); }}>← Личный кабинет</a>
          </div>
          <Page />
        </div>
      );
    }
    return <ProfileHome />;
  }
}

export const ProfileApp = observer(ProfileAppView, ['authStore']);



// WEBPACK FOOTER //
// ./app/javascript/website_newgen/js/components/Profile/ProfileApp.jsx